import React from 'react';
import { cn } from '../../lib/cn';

export const Input = React.forwardRef(function Input(
  { className, variant = 'default', ...props },
  ref
) {
  const classes = cn(
    'ds-input',
    variant === 'inline' && 'ds-input--inline',
    className
  );

  return <input ref={ref} className={classes} {...props} />;
});
